import { Icon } from "@iconify/react/dist/iconify.js";
import {
  Input,
  Upload,
  Form,
  Space,
  Typography,
  Image,
  Select,
  message,
  DatePicker,
  Modal,
  AutoComplete,
} from "antd";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  addDoctor,
  deleteLocationById,
  getDoctorDetails,
  updateDoctor,
} from "../../api/Doctor";
import Loader from "../../customJS/Loader";
import useAuthService from "../../session/useAuthService";
import * as configuration from "../../config/app-config.js";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  getBase64,
  handleage,
  handleonlyNumber,
  preventDefaultEnter,
} from "../../customJS/custom.js";
import { getAllHospitalName } from "../../api/Hospital.js";
import {
  HospitalSelect,
  SmartSelect,
} from "../Components/CustomSelectWithAdd.jsx";

const { Title } = Typography;

export const AddDoctor = () => {
  const [form] = Form.useForm();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [doctorData, setDoctorData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [locationToRemove, setLocationToRemove] = useState(null);
  const [hospitalNames, setHospitalNames] = useState([]);
  const doctorSpecialities = useSelector(({ main }) => main.specialities);
  const [selectedClinic, setSelectedClinic] = useState({
    id: "",
    name: "",
    isNew: false,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [options, setOptions] = useState([]);
  const google = window.google;

  const [messageApi, contextHolder] = message.useMessage();

  const gender = [
    { label: "Male", value: "MALE" },
    { label: "Female", value: "FEMALE" },
    { label: "Others", value: "OTHERS" },
  ];

  // const isAdminNew = useAuthService.getUserType() === "1" && !isEdit;

  const isAdmin = useAuthService.getUserType() === "1";

  useEffect(() => {
    console.log("selectedClinic", selectedClinic);
    console.log(window.location.pathname.trim().endsWith("/editDoctor/"));

    if (window.location.pathname.trim().endsWith("/editDoctor/")) {
      setIsEdit(true);
      console.log("location.state.doctorId", location?.state);
      if (!(location?.state?.doctorId && location?.state?.userId)) {
        navigate(-1);
      } else {
        getDoctorData(location.state);
      }
      console.log(location.state);
    } else if (isAdmin) {
      getAllHospitalNameApi();
    }
  }, [doctorSpecialities]);

  // useEffect(() => {
  // console.log("doctorData?.doctorDetails:", doctorData?.doctorDetails?.hostpitalId);

  //   if (isAdmin && isEdit && doctorData?.doctorDetails?.hostpitalId) {
  //     getAllHospitalNameApi(doctorData?.doctorDetails?.hostpitalId);
  //     alert("ifCondition");
  //   }else if(!isEdit){
  //     getAllHospitalNameApi();
  //     alert("elseCondition");
  //   }
  // }, [doctorData]);

  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
    },
  };

  const onFinish = (values) => {
    console.log("Success11values:", values);

    const formData = new FormData();

    formData.append("displayName", values.displayName);
    formData.append("name", values.name);
    formData.append("speciality", values.speciality);
    formData.append("bio", values.bio || "");
    formData.append("mailId", values.mailId || "");
    formData.append("phoneNo", values.phoneNo || "");
    formData.append("website", values.website || "");
    formData.append("gender", values.gender || "");
    formData.append("age", values.age || "");
    formData.append("overview", values.overview || "");
    formData.append("createdBy", useAuthService.getAuthId());
    formData.append("userType", useAuthService.getUserType());

    // formData.append("locations", values.locations);

    const cleanedLocations = Array.isArray(values.locations)
      ? values.locations.filter(
          (loc) =>
            loc &&
            typeof loc === "object" &&
            Object.keys(loc).length > 0 && // has at least one key
            Object.values(loc).some(
              (value) => value !== "" && value !== null && value !== undefined
            ) // has at least one meaningful value
        )
      : [];

    formData.append("locations", JSON.stringify(cleanedLocations));

    // let updatedExperiences = values.experiences.forEach((exp) => {
    //   const formatDate = (dateString) => {
    //     const date = new Date(dateString);

    //     // Check if the date is valid
    //     if (isNaN(date.getTime())) {
    //       return null; // Return null if the date is invalid
    //     }

    //     return (
    //       date.getFullYear() +
    //       "-" +
    //       String(date.getMonth() + 1).padStart(2, "0") +
    //       "-" +
    //       String(date.getDate()).padStart(2, "0")
    //     );
    //   };

    //   exp.startYear = formatDate(exp.startYear);
    //   exp.endYear = formatDate(exp.endYear);
    // });
    if (values.experiences) {
      let updatedExperiences = values.experiences.map((exp) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);

          // Check if the date is valid
          if (isNaN(date.getTime())) {
            return null; // Return null if the date is invalid
          }

          return (
            date.getFullYear() +
            "-" +
            String(date.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(date.getDate()).padStart(2, "0")
          );
        };

        return {
          experience: exp.experience,
          // ...exp, // Copy all existing properties
          startYear: formatDate(exp.startYear), // Add formatted startYear
          endYear: formatDate(exp.endYear), // Add formatted endYear
        };
      });
      // if (values.experiences.length === 0) {
      //   formData.append("experiences", values.experiences);
      // } else {
      formData.append("experiences", JSON.stringify(updatedExperiences));
      // }
    } else {
      formData.append("experiences", values.experiences || "");
    }

    // console.log("values.experiences", values.experiences, updatedExperiences);
    if (values.upload && values.upload[0]?.originFileObj) {
      formData.append("upload", values.upload[0].originFileObj);
    }

    formData.append("url", configuration.changePasswordUrl);

    if (values?.hospitalId?.isNew && isAdmin) {
      formData.append("isNewClinic", values?.hospitalId.isNew);
      formData.append("hospitalName", values?.hospitalId.name);
      formData.append("clinicMailId", values?.clinicMailId);
    } else if (isAdmin) {
      formData.append("isNewClinic", false);
      formData.append("hospitalId", values?.hospitalId?.id || 0);
    }

    console.log("values.locations::::", values.locations);
    if (isEdit) {
      // if (!isAdmin) {
      //   formData.append("hospitalId", doctorData.hostpitalId);
      // }

      formData.append("doctorId", location.state.doctorId);
      formData.append("userId", location.state.userId);
      editDoctor(formData);
    } else {
      saveDoctor(formData);
    }
  };

  const getDoctorData = (obj) => {
    getDoctorDetails(obj)
      .then((response) => {
        if (response.data.status === 1) {
          console.log("Success:", response.data.data);
          const data = response.data.data;
          form.setFieldsValue({
            displayName: data.doctorDetails.displayName,
            name: data.doctorDetails.fullname,
            speciality: data.doctorDetails.speciality,
            bio: data.doctorDetails.bio,
            mailId: data.doctorDetails.mailId,
            phoneNo: data.doctorDetails.phoneNo,
            website: data.doctorDetails?.website ?? "",
            age: data.doctorDetails.age,
            gender: data.doctorDetails.gender,
            overview: data.doctorDetails?.overview,
            // hospitalId: data.doctorDetails?.hostpitalId,
            experiences:
              data.doctorDetails?.experiences &&
              data.doctorDetails?.experiences !== "undefined"
                ? JSON.parse(data.doctorDetails?.experiences)?.map((exp) => ({
                    ...exp,
                    startYear: exp.startYear ? dayjs(exp.startYear) : null,
                    endYear: exp.endYear ? dayjs(exp.endYear) : null,
                  }))
                : "",
            locations: data.locations?.map((location) => ({
              ...location,
              // hospitalName: location.hospitalName,
              // hospitalAddress: location.hospitalAddress,
              // zipCode: location.zipCode,
            })),
          });

          if (data.doctorDetails.image) {
            // If there is an existing image, set it in the fileList and preview
            const existingFile = {
              uid: "-1", // Unique identifier for the file
              name: doctorData.image,
              status: "done", // Set the status to 'done'
              url: `${configuration.API_URL}auth/assets/${data.doctorDetails.image}`,
            };
            setFileList([existingFile]);
            setPreviewImage(existingFile.url);
          }

          setDoctorData(data);
          getAllHospitalNameApi(data?.doctorDetails?.hostpitalId);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const saveDoctor = (values) => {
    setLoader(true);
    addDoctor(values)
      .then((response) => {
        if (response.data.status === 1) {
          console.log("Success:", response.data);
          messageApi.open({
            type: "success",
            content: "Provider Added successfully",
            duration: 1,
            className: "ant-alert",
          });
          navigate(-1);
          setLoader(false);
        } else if (response.data.status === -2) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else if (response.data.status === -3) {
          messageApi.open({
            type: "error",
            content: "Provider Email-Id is already exists",
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else {
          setLoader(false);
          messageApi.open({
            type: "error",
            content: "Something went wrong",
            duration: 1,
            className: "ant-alert",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const editDoctor = (values) => {
    setLoader(true);
    updateDoctor(values)
      .then((response) => {
        if (response.data.status === 1) {
          console.log("Success:", response.data);
          messageApi.open({
            type: "success",
            content: "Provider Updated Successfully",
            duration: 1,
            className: "ant-alert",
          });
          navigate(-1);
          setLoader(false);
        } else if (response.data.status === -2) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else if (response.data.status === -3) {
          messageApi.open({
            type: "error",
            content: "Provider Email-Id is already exists",
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else {
          setLoader(false);
          messageApi.open({
            type: "error",
            content: "Something went wrong",
            duration: 1,
            className: "ant-alert",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const deleteLocation = (values) => {
    setLoader(true);
    deleteLocationById(values)
      .then((response) => {
        if (response.data.status === 1) {
          console.log("Success:", response.data);
          locationToRemove.removeFn(locationToRemove.name);
          setIsModalVisible(false);
          setLocationToRemove(null);
          messageApi.open({
            type: "success",
            content: "Location deleted successfully",
            duration: 1,
            className: "ant-alert",
          });
          // navigate("/clinic/doctors");
          setLoader(false);
        } else {
          setLoader(false);
          messageApi.open({
            type: "error",
            content: "Something went wrong",
            duration: 1,
            className: "ant-alert",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  function getAllHospitalNameApi(hospitalId) {
    setLoader(true);
    getAllHospitalName({})
      .then((response) => {
        if (response.data.status === 1) {
          setLoader(false);
          setHospitalNames(response.data.data);

          console.log("doctorDatahostpitalId::", hospitalId);

          if (hospitalId) {
            const selected = response.data.data.find(
              (h) => h.id === hospitalId
            );

            const data = {
              id: selected?.id,
              name: selected?.name,
              isNew: false,
            };

            console.log("dataselected:::", response.data.data, selected, data);

            form.setFieldsValue({ hospitalId: data });

            setSelectedClinic(data);
          }
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.error("Error fetching hospital data:", error.message);
      });
  }

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // const getBase64 = (file) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => resolve(reader.result);
  //     reader.onerror = (error) => reject(error);
  //   });

  const preventEnterKey = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const showDeleteConfirm = (name, removeFn, id) => {
    console.log("showDeleteConfirm::", name, removeFn, id);
    setLocationToRemove({ name, removeFn, id });
    setIsModalVisible(true);
  };

  const handleDelete = () => {
    if (locationToRemove) {
      // console.log("locationToRemove", locationToRemove);
      if (locationToRemove.id) {
        deleteLocation({ id: locationToRemove.id });
      } else {
        locationToRemove.removeFn(locationToRemove.name);
        setIsModalVisible(false);
        setLocationToRemove(null);
      }
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setLocationToRemove(null);
  };

  const fetchPlaceSuggestions = async (query) => {
    if (!query) {
      setOptions([]);
      return;
    }

    const autocompleteService = new google.maps.places.AutocompleteService();
    autocompleteService.getPlacePredictions(
      { input: query },
      (predictions, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          setOptions(
            predictions.map((prediction) => ({
              value: prediction.description,
              placeId: prediction.place_id,
            }))
          );
        }
      }
    );
  };

  const handlePlaceSelect = (value, index) => {
    const placesService = new google.maps.places.PlacesService(
      document.createElement("div")
    );
    const selectedOption = options.find((option) => option.value === value);

    if (selectedOption) {
      placesService.getDetails(
        { placeId: selectedOption.placeId },
        (place, status) => {
          if (
            status === google.maps.places.PlacesServiceStatus.OK &&
            place.geometry
          ) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            // Update the form with the selected place data
            const locations = form.getFieldValue("locations") || [];
            locations[index] = {
              ...locations[index],
              hospitalAddress: value,
              latitude: lat,
              longitude: lng,
            };
            form.setFieldsValue({ locations });
          }
        }
      );
    }
  };

  const handleAddNew = (newName) => {
    const newId = Math.max(...hospitalNames.map((item) => item.id), 0) + 1;
    setHospitalNames([...hospitalNames, { id: newId, name: newName }]);
  };

  // useEffect(() => {
  //   console.log("previewImage::", fileList.length);
  // }, [fileList]);

  return (
    <Row className="m-0">
      {loader && <Loader />}
      {contextHolder}

      {isModalVisible && (
        <Modal
          title="Confirm Delete"
          open={isModalVisible}
          onOk={handleDelete}
          onCancel={handleCancel}
          okText="Yes, Delete"
          cancelText="Cancel"
        >
          <p>Are you sure you want to delete this location?</p>
        </Modal>
      )}

      <Col xs="12">
        <Row className="m-0">
          <Col>
            <h2 className="m-4 uniteColor font-weight700">
              {isEdit ? "Edit" : "Add"} Provider
            </h2>
          </Col>
          <Col className="d-flex justify-content-end align-items-center">
            <Button className="uniteButton" onClick={() => navigate(-1)}>
              <Icon icon="famicons:arrow-back" />
              Back
            </Button>
          </Col>
        </Row>

        <Row className="m-4">
          <Col>
            <h5 className="uniteColor">Title Details</h5>
            <p className="unitedTextColor">
              This name will be displayed as the primary title.
            </p>
          </Col>

          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            // onKeyDown={preventEnterKey}
            validateMessages={validateMessages}
          >
            {/* Title Details */}
            <Row>
              <Col md="6" xs="12">
                <Form.Item
                  label="Display Name"
                  name="displayName"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Enter display name" />
                </Form.Item>
              </Col>
              <Col md="6" xs="12">
                <Form.Item
                  label="Full Name"
                  name="name"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Enter full name" />
                </Form.Item>
              </Col>
              <Col md={isAdmin ? "3" : "6"} xs="12">
                <Form.Item
                  label="Speciality"
                  name="speciality"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Select speciality" size="large">
                    {doctorSpecialities?.map((item) => (
                      <Select.Option key={item.value} value={item.id}>
                        {item.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md="4" xs="12">
                <Form.Item
                  label="Gender"
                  name="gender"
                  rules={[{ required: !isAdmin }]}
                >
                  <Select
                    placeholder="Select gender"
                    size="large"
                    options={gender}
                  >
                    {/* {gender.map((item, index) => (
                      <Select.Option key={index}  value={item.label}>
                        {item.label}
                      </Select.Option>
                    ))} */}
                  </Select>
                </Form.Item>
              </Col>
              <Col md="2" xs="12">
                <Form.Item
                  label="Age"
                  name="age"
                  rules={[{ required: !isAdmin }]}
                >
                  <Input placeholder="Enter Age" onKeyPress={handleage} />
                </Form.Item>
              </Col>

              <Col md="6" xs="12">
                <Form.Item
                  label="Bio"
                  name="bio"
                  rules={[{ required: !isAdmin }]}
                >
                  <Input.TextArea rows={4} placeholder="Enter bio" />
                </Form.Item>
              </Col>
              <Col md="6" xs="12">
                <Form.Item
                  label="Display Image"
                  name="upload"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e?.fileList}
                >
                  <Upload
                    listType="picture-card"
                    onPreview={handlePreview}
                    onChange={({ fileList }) => {
                      const normalizedFileList = fileList.map((file) => ({
                        ...file,
                        status: "done", // Set status to 'done' for proper rendering
                      }));
                      setFileList(normalizedFileList); // Update local state
                      form.setFieldsValue({ upload: normalizedFileList }); // Sync with Form stateu
                    }}
                    fileList={fileList}
                    maxCount={1}
                    // beforeUpload={() => false}

                    beforeUpload={(file) => {
                      const isAllowedType = [
                        "image/jpeg",
                        "image/jpg",
                        "image/png",
                      ].includes(file.type);
                      if (!isAllowedType) {
                        messageApi.error(
                          "You can only upload PNG, JPG, or JPEG files!"
                        );
                      }
                      return isAllowedType ? false : Upload.LIST_IGNORE;
                    }}
                  >
                    <Icon
                      icon={
                        fileList.length === 0
                          ? "fluent:add-32-regular"
                          : "tabler:edit"
                      }
                      width="14"
                      height="14"
                      style={{ color: "#a7a7a7" }}
                    />{" "}
                    &ensp;{fileList.length === 0 ? "Add" : "Edit"}
                  </Upload>
                  {previewImage && (
                    <Image
                      title=""
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col md="12" xs="12">
                <Form.Item
                  label="Overview"
                  name="overview"
                  rules={[{ required: !isAdmin }]}
                >
                  <Input.TextArea rows={4} placeholder="Enter overview" />
                </Form.Item>
              </Col>
            </Row>

            <h5 className="uniteColor">Contact</h5>
            <Row>
              <Col md={6} xs={12}>
                <Form.Item
                  label="Email"
                  name="mailId"
                  rules={[
                    { required: !isAdmin },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input placeholder="Enter email" />
                </Form.Item>
              </Col>
              <Col md={6} xs={12}>
                <Form.Item
                  label="Contact Number"
                  name="phoneNo"
                  rules={[{ required: !isAdmin }]}
                >
                  <Input
                    placeholder="Enter contact number"
                    onKeyPress={handleonlyNumber}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="Website (For Booking)"
              name="website"
              // rules={[{ required: false }]}
              rules={[
                { required: !isAdmin },
                { message: "Please enter a valid website" },
              ]}
            >
              <Input placeholder="Enter website URL" />
            </Form.Item>
            <Form.List name="experiences">
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div
                      key={key}
                      style={{
                        marginBottom: 24,
                        padding: 16,
                        border: "1px solid #f0f0f0",
                        borderRadius: 8,
                      }}
                    >
                      <Form.Item
                        label={index === 0 ? "Experience with Years" : ""}
                        required={false}
                      >
                        <div className="d-flex ">
                          <Form.Item
                            {...restField}
                            name={[name, "experience"]}
                            rules={[
                              {
                                required: !isAdmin,
                                message: "Please input your experience!",
                              },
                            ]}
                            style={{ flex: 3, marginRight: 8 }}
                          >
                            <Input
                              placeholder="Experience"
                              onKeyDown={(e) => preventDefaultEnter(e)}
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, "startYear"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input the starting year!",
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const endYear = getFieldValue([
                                    "experiences",
                                    name,
                                    "endYear",
                                  ]);
                                  if (!value || !endYear || value <= endYear) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    new Error("Please chooose valid date!")
                                  );
                                },
                              }),
                            ]}
                            style={{ flex: 1, marginRight: 8 }}
                          >
                            <DatePicker
                              onKeyDown={(e) => preventDefaultEnter(e)}
                              picker="year"
                              size="large"
                              placeholder="Start Year"
                              style={{ width: "100%" }}
                              disabledDate={(current) =>
                                current && current > new Date()
                              }
                            />
                          </Form.Item>

                          {/* End Year */}
                          <Form.Item
                            {...restField}
                            name={[name, "endYear"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input the ending year!",
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  const startYear = getFieldValue([
                                    "experiences",
                                    name,
                                    "startYear",
                                  ]);
                                  if (
                                    !value ||
                                    !startYear ||
                                    value >= startYear
                                  ) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    new Error("Please chooose valid date!")
                                  );
                                },
                              }),
                            ]}
                            style={{ flex: 1, marginRight: 8 }}
                          >
                            <DatePicker
                              onKeyDown={(e) => preventDefaultEnter(e)}
                              picker="year"
                              size="large"
                              placeholder="End Year"
                              style={{ width: "100%" }}
                              disabledDate={(current) =>
                                current && current > new Date()
                              }
                            />
                          </Form.Item>

                          <Icon
                            icon="fluent:delete-32-regular"
                            width="20"
                            height="20"
                            className="cursor-pointer mt-2"
                            onClick={() => remove(name)}
                            style={{ color: "#ff4d4f" }}
                          />
                        </div>
                      </Form.Item>
                    </div>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      className="uniteButton-outline"
                    >
                      <Icon icon="majesticons:plus" /> Add Experience
                    </Button>
                    {fields.length >= 1 ? (
                      <Button
                        type="dashed"
                        className="uniteButton-outline ms-3"
                        onClick={() => {
                          add("", 0);
                        }}
                      >
                        <Icon icon="majesticons:plus" /> Add Experience at Head
                      </Button>
                    ) : null}
                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}
            </Form.List>

            <h5 className="uniteColor">Locations</h5>

            <Form.List name="locations" initialValue={[{}]}>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    // Use the `useFormInstance` hook to access the `id` for the current location
                    // const form = Form.useFormInstance();
                    const id = form.getFieldValue(["locations", name, "id"]); // Access `id` for the current field

                    return (
                      <div
                        key={key}
                        style={{
                          marginBottom: 24,
                          padding: 16,
                          border: "1px solid #f0f0f0",
                          borderRadius: 8,
                        }}
                      >
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          align="start"
                        >
                          <Title type="secondary" level={5}>
                            Location {index + 1}
                          </Title>
                          <Icon
                            icon="iconoir:cancel"
                            width="24"
                            height="24"
                            onClick={() => showDeleteConfirm(name, remove, id)} // Pass `id` to your confirm function
                            style={{
                              color: "#a7a7a7",
                              cursor: "pointer",
                            }}
                          />
                        </Space>
                        <Row>
                          <Col md={6} xs={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "hospitalName"]}
                              label="Provider Name"
                              rules={[
                                {
                                  required: !isAdmin,
                                  message: "Provider Name is required",
                                },
                              ]}
                              style={{ flex: 1, marginRight: 8 }}
                            >
                              <Input placeholder="Enter Provider name" />
                            </Form.Item>
                          </Col>

                          <Col md={6} xs={12}>
                            <Form.Item
                              {...restField}
                              name={[name, "hospitalAddress"]}
                              label="Provider Address"
                              rules={[
                                {
                                  required: !isAdmin,
                                  message: "Provider Address is required",
                                },
                              ]}
                            >
                              <AutoComplete
                                placeholder="Enter provider address"
                                options={options}
                                onSearch={fetchPlaceSuggestions}
                                onSelect={(value) =>
                                  handlePlaceSelect(value, index)
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Hidden field to store the ID */}
                          <Form.Item
                            {...restField}
                            name={[name, "id"]}
                            style={{ display: "none" }}
                          >
                            <Input type="hidden" />
                          </Form.Item>
                        </Row>
                      </div>
                    );
                  })}

                  <Form.Item>
                    <Button
                      className="uniteButton-outline"
                      onClick={() => add()}
                    >
                      Add New
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            {isAdmin && (
              <Row>
                <Col md="6" xs="12">
                  <Form.Item
                    label="Provider Name"
                    name="hospitalId"
                    // rules={[{ required: true }]}
                  >
                    <HospitalSelect
                      hospitalNames={hospitalNames}
                      selectedClinic={selectedClinic}
                      onChange={setSelectedClinic}
                    />
                    {/* <p>Current selection: {selectedClinic.name}</p> */}
                  </Form.Item>
                </Col>

                {isAdmin && selectedClinic.isNew && (
                  <Col md={6} xs={12}>
                    <Form.Item
                      label="Provider's office email"
                      name="clinicMailId"
                      rules={[
                        { required: true },
                        // {
                        //   type: "email",
                        //   message: "Please enter a valid email",
                        // },
                      ]}
                    >
                      <Input placeholder="Enter email" />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            )}

            <Form.Item>
              <Button type="primary">
                {" "}
                {isEdit ? "Update Provider" : "Add Provider"}
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Col>
    </Row>
  );
};
